import { render, staticRenderFns } from "./preview-form.vue?vue&type=template&id=e72bf852&scoped=true&"
import script from "./preview-form.vue?vue&type=script&lang=js&"
export * from "./preview-form.vue?vue&type=script&lang=js&"
import style0 from "./preview-form.vue?vue&type=style&index=0&id=e72bf852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72bf852",
  null
  
)

export default component.exports